import { MgNoise, MgPrescription, MgQuestion, MgWifi } from '@montugroup/icons';
import { Box, Typography } from '@mui/material';

type ItemProps = {
  IconStart?: React.ComponentType;
  children: React.ReactNode;
};

const Item = ({ IconStart, children }: ItemProps) => (
  <Box display="flex" flexDirection="row" alignItems="flex-start" mb="1rem">
    <Box sx={{ marginRight: '1rem', userSelect: 'none', color: 'primary.main' }}>{IconStart && <IconStart />}</Box>
    <Typography variant="body1" mt="0.2rem">
      {children}
    </Typography>
  </Box>
);

export default function WhatToBring() {
  return (
    <Box mb="2.5rem">
      <Typography
        variant="h5"
        component="h2"
        sx={(theme) => ({ color: theme.palette.primary.main, marginBottom: theme.spacing(6) })}
      >
        What to bring to your session
      </Typography>

      <Box display="flex" flexDirection="column">
        <Item IconStart={MgPrescription}>
          A list of current prescription medications, including dosage and frequency
        </Item>
        <Item IconStart={MgQuestion}>Any questions and concerns you may have</Item>
        <Item IconStart={MgWifi}>Stable internet connection and you are on a device with a camera and microphone</Item>
        <Item IconStart={MgNoise}>Find a quiet and private space for the consultation to ensure confidentiality</Item>
      </Box>
    </Box>
  );
}
